import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { ICandidate } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { useCandidateViewData } from '../../../utils/CandidateViewContext';
import CardWithAccordion from '../CardWithAccordion';

export interface CandidateExperienceCardProps {
  title: string;
  candidate: ICandidate;
}

const CandidateExperienceCard = ({ title, candidate }: CandidateExperienceCardProps) => {
  const { candidateViewData } = useCandidateViewData();
  const isInDnc =
    (candidateViewData?.dnc?.isDeleted ?? false) || (candidateViewData?.dnc?.isInDnc ?? false);
  return (
    <CardWithAccordion
      title={title}
      topChild={
        <>
          {isInDnc && (
            <Grid xs={12} ml={7.5}>
              <WsTypography>No Data To Show</WsTypography>
            </Grid>
          )}
          {!isInDnc &&
            candidate.experience?.current &&
            !isEmpty(candidate.experience?.current.org) && (
              <>
                <Grid container alignItems="center" justifyContent="space-between" sx={{ p: 1 }}>
                  <Grid item>
                    <WsTypography bold={true}>{candidate.experience?.current.org}</WsTypography>

                    <WsTypography>{candidate.experience?.current.title ?? ''}</WsTypography>
                  </Grid>

                  <Grid item sx={{ mt: candidate.experience?.current.periodStart ? 0 : 2 }}>
                    <WsTypography>
                      {candidate.experience?.current.periodStart && (
                        <>
                          {new Date(
                            candidate.experience.current.periodStart.year,
                            candidate.experience.current.periodStart.month - 1,
                            candidate.experience.current.periodStart.day
                          ).toLocaleDateString('en-US', { month: 'short' })}{' '}
                          {candidate.experience.current.periodStart.year}
                          {' to Present'}
                        </>
                      )}
                    </WsTypography>
                  </Grid>
                </Grid>
              </>
            )}
        </>
      }
      bottomChild={
        <>
          {!isInDnc &&
            !isEmpty(candidate.experience?.history) &&
            candidate.experience?.history?.map((item, index) => (
              <Grid
                key={index}
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Grid>
                  <Grid item gap={1} display="flex">
                    {item.org && <WsTypography bold={true}>{item.org}</WsTypography>}
                  </Grid>
                  <Grid item>
                    <WsTypography>{item.title}</WsTypography>
                  </Grid>
                </Grid>
                <Grid item>
                  <WsTypography>
                    {item.periodStart && (
                      <>
                        {new Date(
                          item.periodStart.year,
                          item.periodStart.month - 1,
                          item.periodStart.day
                        ).toLocaleDateString('en-US', { month: 'short' })}{' '}
                        {item.periodStart.year} -{' '}
                        {item.periodEnd
                          ? `${new Date(
                              item.periodEnd.year,
                              item.periodEnd.month - 1,
                              item.periodEnd.day
                            ).toLocaleDateString('en-US', { month: 'short' })} ${
                              item.periodEnd.year
                            }`
                          : 'Not Avaliable'}
                      </>
                    )}
                  </WsTypography>
                </Grid>
              </Grid>
            ))}
        </>
      }
      hasData={!isEmpty(candidate?.experience?.current) || !isEmpty(candidate?.experience?.history)}
    ></CardWithAccordion>
  );
};

export default CandidateExperienceCard;
